module.exports = __webpack_public_path__ + "img/doc.c8fb6006.png";